import Joi from "joi";

export default function validator(values, type = "full", translator) {
  const emailSchema = Joi.object({
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.email": translator("demoForm.errors.email.invalid"),
        "string.empty": translator("demoForm.errors.email.empty"),
        "any.required": translator("demoForm.errors.email.required"),
      }),
  });

  const noSchema = Joi.object({
    ownsAsset: Joi.string()
      .valid("yes", "no")
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.ownsAsset.only"),
        "any.only": translator("demoForm.errors.ownsAsset.only"),
        "any.required": translator("demoForm.errors.ownsAsset.required"),
      }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.email": translator("demoForm.errors.email.invalid"),
        "string.empty": translator("demoForm.errors.email.empty"),
        "any.required": translator("demoForm.errors.email.required"),
      }),
    phoneNumber: Joi.string()
      .allow("")
      .optional()
      .messages({
        "string.empty": translator("demoForm.errors.phone.empty"),
      }),
  });

  const fullSchema = Joi.object({
    companyName: Joi.string()
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.assetProjectName.empty"),
        "any.required": translator("demoForm.errors.assetProjectName.empty"),
      }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.email": translator("demoForm.errors.email.invalid"),
        "string.empty": translator("demoForm.errors.email.empty"),
        "any.required": translator("demoForm.errors.email.required"),
      }),
    phoneNumber: Joi.string()
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.phone.empty"),
        "any.required": translator("demoForm.errors.phone.required"),
      }),
    ownsAsset: Joi.string()
      .valid("yes", "no")
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.ownsAsset.only"),
        "any.only": translator("demoForm.errors.ownsAsset.only"),
        "any.required": translator("demoForm.errors.ownsAsset.required"),
      }),

    assetProjectName: Joi.string()
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.assetProjectName.empty"),
        "any.required": translator("demoForm.errors.assetProjectName.empty"),
      }),
    location: Joi.string()
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.location.empty"),
        "any.required": translator("demoForm.errors.location.empty"),
      }),
    gps: Joi.string()
      .pattern(
        /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
      )
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.gps.invalid"),
        "any.required": translator("demoForm.errors.gps.invalid"),
        "string.pattern.base": translator("demoForm.errors.gps.invalid"),
      }),
    quantityUnit: Joi.string()
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.quantityUnit.empty"),
        "any.required": translator("demoForm.errors.quantityUnit.empty"),
      }),
    project_type: Joi.string()
      .valid(
        "syntropic",
        "conservation",
        "reforestation",
        "biodevirsity_and_ecosystem_management",
        "agroforestry",
        "other"
      )
      .required()
      .messages({
        "any.only": translator("demoForm.errors.project_type.only"),
        "any.required": translator("demoForm.errors.project_type.only"),
        "string.empty": translator("demoForm.errors.project_type.only"),
      }),
    project_type_other: Joi.string()
      .when("project_type", {
        is: "other",
        then: Joi.string()
          .trim()
          .required()
          .messages({
            "string.empty": translator("demoForm.errors.project_type_other.empty"),
            "any.required": translator("demoForm.errors.project_type_other.empty"),
          }),
        otherwise: Joi.string().allow("").optional(),
      }),
    openEnded: Joi.string()
      .required()
      .messages({
        "string.empty": translator("demoForm.errors.openEnded.empty"),
        "any.required": translator("demoForm.errors.openEnded.empty"),
      }),
  });

  let schema;
  if (type === "email") {
    schema = emailSchema;
  } else if (values.ownsAsset === "no") {
    schema = noSchema;
  } else {
    schema = fullSchema;
  }

  const { error } = schema.validate(values, { abortEarly: false });
  const errors = {};

  if (error) {
    error.details.forEach((detail) => {
      const field = detail.path[0];
      errors[`error_${field}`] = detail.message;
    });
  }

  return errors;
}
